import * as React from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import AppStarLogo from "../images/appstar_title_tr.png";

import FormControl from "@mui/material/FormControl";
import {
  IconButton,
  InputAdornment,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import axios from "axios";
import { SuccessRegister } from "./SuccessRegister";
import { serverDomain, siteKey } from "./config";
import { useTheme } from "@mui/material/styles";
import RecaptchaEnterprise from "../components/RecaptchaEnterprise";
import { Link as RouterLink } from "react-router-dom";
import Copyright from "../components/Copyright";

const theme = createTheme();

//set default values for the form fields
const defaultValues = {
  first_name: "",
  last_name: "",
  username: "",
  email: "",
  password: "",
  confirmPassword: "",
  token: "",
};

export default function SignUp3(props) {
  const theme = useTheme();
  const [formValues, setFormValues] = React.useState(defaultValues);
  const [errors, setErrors] = React.useState({});
  const [success, setSuccess] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const [agreedToTerms, setAgreedToTerms] = React.useState(false);
  const recaptchaRef = React.useRef(null);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  };

  const handleClickShowConfirmPassword = () => {
    setShowConfirmPassword((prev) => !prev);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  // reCAPTCHA handlers
  const handleRecaptchaSuccess = React.useCallback((token) => {
    setFormValues((f) => ({ ...f, token }));
    setErrors((e) => ({ ...e, invalidRecaptcha: "" }));
  }, []);

  const handleRecaptchaExpired = React.useCallback(() => {
    setFormValues((f) => ({ ...f, token: "" }));
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (validate()) {
      // Log params being sent to server
      console.log("Submitting signup with params:", {
        first_name: formValues.first_name,
        last_name: formValues.last_name,
        username: formValues.username,
        email: formValues.email,
        password: formValues.password,
        reCAPTCHA_token: formValues.token,
      });

      axios
        .post(serverDomain + "signup.php", null, {
          params: {
            first_name: formValues.first_name,
            last_name: formValues.last_name,
            username: formValues.username,
            email: formValues.email,
            password: formValues.password,
            reCAPTCHA_token: formValues.token,
          },
        })
        .then((response) => {
          if (response.data.success) {
            console.log(response.data.message);
            setSuccess(true);
          } else {
            console.log("Not registered", response);
            
            // Reset reCAPTCHA
            if (recaptchaRef.current && recaptchaRef.current.reset) {
              recaptchaRef.current.reset();
            }
            
            setFormValues({
              ...formValues,
              token: "",
            });
            
            console.log("Not registered error message", response.data.message);
            const errorMessage = response.data.message;
            
            // Clear all previous errors before setting new ones
            const newErrors = {};
            
            if (errorMessage.includes("mail")) {
              newErrors.email = errorMessage;
            }
            if (errorMessage.includes("password")) {
              newErrors.password = errorMessage;
            }
            if (errorMessage.includes("name")) {
              newErrors.username = errorMessage;
            }
            if (errorMessage.includes("reCAPTCHA")) {
              newErrors.invalidRecaptcha = errorMessage;
            }
            
            setErrors(newErrors);
          }
        })
        .catch((error) => {
          console.log("Error", error);
        });
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });

    // Validate the input fields
    validateField(name, value);
  };

  const validateField = (name, value) => {
    let tempErrors = { ...errors };

    switch (name) {
      case "password":
        if (value.length < 12) {
          tempErrors.password = "Password must be at least 12 characters long";
        } else if (
          !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*#?&-])[A-Za-z\d@$!%*#?&-]{12,}$/.test(
            value
          )
        ) {
          tempErrors.password =
            "Password must be at least 12 characters long and should contain at least one uppercase letter, one lowercase letter, one number and one special character from @$!%*#?&-";
        } else {
          tempErrors.password = "";
        }
        tempErrors.confirmPassword =
          value !== formValues.confirmPassword ? "Passwords don't match" : "";
        break;
      case "confirmPassword":
        tempErrors.confirmPassword =
          value !== formValues.password ? "Passwords don't match" : "";
        break;
      default:
        break;
    }

    setErrors(tempErrors);
  };

  const validate = () => {
    console.log("inside validate..");
    const temp = {};
    temp.first_name = formValues.first_name ? "" : "First name is required";
    temp.last_name = formValues.last_name ? "" : "Last name is required";
    temp.username = formValues.username
      ? /.{3,}/.test(formValues.username)
        ? ""
        : "Username must be at least 3 characters long"
      : "Username is required";
    temp.email = formValues.email
      ? /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/.test(
          formValues.email
        )
        ? ""
        : "Email is not valid"
      : "Email is required";

    console.log("temp:", { ...temp });
    setErrors({
      ...temp,
    });
    return Object.values(temp).every((x) => x === "");
  };

  return (
    <>
      {success ? (
        <SuccessRegister
          email={formValues.email}
          fullName={`${formValues.first_name || ""} ${
            formValues.last_name || ""
          }`.trim()}
        />
      ) : (
        <ThemeProvider theme={theme}>
          <Container component="main" maxWidth="sm">
            <Box
              sx={{
                marginTop: 4,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src={AppStarLogo}
                alt="AppStar Logo"
                style={{ marginBottom: 12, width: 100 }}
              />
              <Typography
                variant="h6"
                sx={{
                  mb: 2,
                  fontWeight: 600,
                  color: theme.palette.mode === 'dark' ? '#ffffff' : '#000000'
                }}
              >
                AppStar.ai
              </Typography>
              <Typography component="h1" variant="h5">
                Sign up
              </Typography>

              <Box
                component="form"
                noValidate
                onSubmit={handleSubmit}
                sx={{ mt: 3, width: "100%" }}
              >
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <TextField
                      required
                      fullWidth
                      id="first_name"
                      label="First Name"
                      name="first_name"
                      type="text"
                      value={formValues.first_name}
                      onChange={handleInputChange}
                      error={!!errors.first_name}
                      helperText={errors.first_name}
                      sx={{ mb: 2 }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <TextField
                      required
                      fullWidth
                      id="last_name"
                      label="Last Name"
                      name="last_name"
                      type="text"
                      value={formValues.last_name}
                      onChange={handleInputChange}
                      error={!!errors.last_name}
                      helperText={errors.last_name}
                      sx={{ mb: 2 }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <TextField
                      required
                      fullWidth
                      id="username"
                      label="Username"
                      name="username"
                      type="text"
                      value={formValues.username}
                      onChange={handleInputChange}
                      error={!!errors.username}
                      helperText={errors.username}
                      sx={{ mb: 2 }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth>
                    <TextField
                      required
                      fullWidth
                      id="email"
                      label="Email Address"
                      name="email"
                      type="email"
                      autoComplete="email"
                      value={formValues.email}
                      onChange={handleInputChange}
                      error={!!errors.email}
                      helperText={errors.email}
                      sx={{ mb: 2 }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sx={{ mb: 2 }}>
                  <FormControl fullWidth>
                    <TextField
                      required
                      fullWidth
                      name="password"
                      label="Choose A New Password"
                      type={showPassword ? "text" : "password"}
                      id="password"
                      autoComplete="new-password"
                      value={formValues.password}
                      onChange={handleInputChange}
                      error={!!errors.password}
                      helperText={errors.password}
                      variant="outlined"
                      InputLabelProps={{
                        sx: (t) => ({
                          backgroundColor: t.palette.background.default,
                          px: 0.5,
                        })
                      }}
                      slotProps={{
                        input: {
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle password visibility"
                                onClick={handleClickShowPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                                size="small"
                              >
                                {showPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                          style: { WebkitTextSecurity: showPassword ? 'none' : 'disc' },
                        },
                      }}
                      inputProps={{
                        style: { WebkitTextSecurity: showPassword ? 'none' : 'disc' },
                      }}
                      sx={{
                        '& input::-ms-reveal': {
                          display: 'none',
                        },
                        '& input::-ms-clear': {
                          display: 'none',
                        },
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sx={{ mb: 2 }}>
                  <FormControl fullWidth>
                    <TextField
                      required
                      fullWidth
                      name="confirmPassword"
                      label="Type Your Password Again"
                      type={showConfirmPassword ? "text" : "password"}
                      id="confirmPassword"
                      autoComplete="new-password"
                      value={formValues.confirmPassword}
                      onChange={handleInputChange}
                      error={!!errors.confirmPassword}
                      helperText={errors.confirmPassword}
                      variant="outlined"
                      InputLabelProps={{
                        sx: (t) => ({
                          backgroundColor: t.palette.background.default,
                          px: 0.5,
                        })
                      }}
                      slotProps={{
                        input: {
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton
                                aria-label="toggle confirm password visibility"
                                onClick={handleClickShowConfirmPassword}
                                onMouseDown={handleMouseDownPassword}
                                edge="end"
                                size="small"
                              >
                                {showConfirmPassword ? (
                                  <VisibilityOff />
                                ) : (
                                  <Visibility />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                          style: { WebkitTextSecurity: showConfirmPassword ? 'none' : 'disc' },
                        },
                      }}
                      inputProps={{
                        style: { WebkitTextSecurity: showConfirmPassword ? 'none' : 'disc' },
                      }}
                      sx={{
                        '& input::-ms-reveal': {
                          display: 'none',
                        },
                        '& input::-ms-clear': {
                          display: 'none',
                        },
                      }}
                    />
                  </FormControl>
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={agreedToTerms}
                        onChange={(e) => setAgreedToTerms(e.target.checked)}
                        color="primary"
                      />
                    }
                    label={
                      <Typography variant="body2">
                        I have read and agree to the{' '}
                        <Link component={RouterLink} to="/privacy-policy" underline="always">
                          privacy policy
                        </Link>
                        {' '}and{' '}
                        <Link component={RouterLink} to="/terms-of-service" underline="always">
                          terms of service
                        </Link>
                      </Typography>
                    }
                  />
                </Grid>

                <Grid item xs={12} sx={{ mt: 2, display: 'flex', justifyContent: 'center' }}>
                  <RecaptchaEnterprise
                    ref={recaptchaRef}
                    siteKey={siteKey}
                    onSuccess={handleRecaptchaSuccess}
                    onExpired={handleRecaptchaExpired}
                    error={errors.invalidRecaptcha}
                  />
                </Grid>

                <Grid item xs={12} sx={{ mt: 2 }}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{
                      mt: 1,
                      mb: 2,
                      backgroundColor: 'var(--dark-blue)',
                      color: '#fff',
                      padding: '0.75rem',
                      "&:hover": {
                        opacity: 0.9,
                      },
                    }}
                    disabled={!formValues.token || !agreedToTerms}
                  >
                    Sign Up
                  </Button>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "flex-end" }}
                >
                  <Link href="login" variant="body2">
                    Already have an account? Sign in
                  </Link>
                </Grid>
              </Box>
            </Box>

            <Copyright sx={{ mt: 5, mb: 2 }} />
          </Container>
        </ThemeProvider>
      )}
    </>
  );
}
